import { Box, Typography } from '@mui/material';
import { CheckCircleIcon, CircleIcon } from 'components/icons';
import { ErrorMessages } from 'forms/error-messages';
import React, { ReactElement } from 'react';
import { theme } from 'theme';

export interface PasswordRequirementsProps {
  errors?: string[];
  dirty?: boolean;
}

export const PasswordRequirements = ({
  errors,
  dirty = false,
}: PasswordRequirementsProps): ReactElement => {
  const passwordTooShort = errors?.includes(ErrorMessages.Password.TOO_SHORT);

  const passwordMissingNumberOrSymbol = errors?.includes(
    ErrorMessages.Password.MISSING_NUMBER_OR_SYMBOL,
  );

  return (
    <>
      <Box
        sx={{
          marginTop: 19,
          fontSize: { xs: 12, md: 14 },
          color: dirty
            ? passwordTooShort
              ? theme.palette.error.main
              : theme.palette.success.main
            : theme.palette.neutral.darker,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {dirty && !passwordTooShort ? <CheckCircleIcon /> : <CircleIcon />}
        <Typography
          style={{ marginLeft: '0.35em', fontSize: '1em', lineHeight: 1 }}
        >
          Password must be 8 characters long.
        </Typography>
      </Box>
      <Box
        sx={{
          fontSize: { xs: 12, md: 14 },
          color: dirty
            ? passwordMissingNumberOrSymbol
              ? theme.palette.error.main
              : theme.palette.success.main
            : theme.palette.neutral.darker,
          display: 'flex',
          alignItems: 'center',
        }}
        pt={8}
      >
        {dirty && !passwordMissingNumberOrSymbol ? (
          <CheckCircleIcon />
        ) : (
          <CircleIcon />
        )}
        <Typography
          style={{ marginLeft: '0.35em', fontSize: '1em', lineHeight: 1 }}
        >
          Password must include a number or symbol.
        </Typography>
      </Box>
    </>
  );
};
